import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';

const SelectedItems = ({ items, getLabel, onRemove, maxVisible = 1 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!items || items.length === 0) return null;

  const shouldCollapse = items.length > maxVisible;

  const visibleItems = expanded ? items : items.slice(0, maxVisible);

  const remaining = items.length - maxVisible;

  return (
    <Box mt={1} display="flex" alignItems="center" gap={1} flexWrap="wrap">
      {visibleItems.map((item) => (
        <Box
          key={item}
          sx={{
            backgroundColor: 'grey.100',
            borderRadius: '20px',
            px: 1.5,
            py: 0.5,
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            fontSize: 13,
            color: 'text.primary',
          }}
        >
          {getLabel(item)}

          <Box
            component="span"
            sx={{
              cursor: 'pointer',
              opacity: 0.6,
              fontSize: 14,
              '&:hover': { opacity: 1 },
            }}
            onClick={() => onRemove(item)}
          >
            ×
          </Box>
        </Box>
      ))}

      {shouldCollapse && !expanded && (
        <Typography
          onClick={() => setExpanded(true)}
          sx={{
            fontSize: 13,
            color: 'primary.main',
            cursor: 'pointer',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          +{remaining} more
        </Typography>
      )}

      {shouldCollapse && expanded && (
        <Typography
          onClick={() => setExpanded(false)}
          sx={{
            fontSize: 13,
            color: 'primary.main',
            cursor: 'pointer',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          View less
        </Typography>
      )}
    </Box>
  );
};

export default SelectedItems;
